<template>
  <div class="content">
    <div class="md-layout">
      <md-card
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-24"
        style="margin: 20px"
      >
        <md-card-header
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
          data-background-color="orange"
        >
          <div class="md-title">
            <md-icon class="md-size-2x">equalizer</md-icon> Siempre
          </div>
        </md-card-header>
        <md-card-content>
          <p v-for="total in totales" :key="total">
            <b>{{ total.tipo }}:</b> ${{ formatPrice(total.monto) }}
          </p>
          <hr />
          <p>
            <b>Total:</b> ${{
              formatPrice(totales[1].monto - totales[0].monto)
            }}
          </p>
        </md-card-content>
      </md-card>
      <md-card
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-24"
        style="margin: 20px"
      >
        <md-card-header
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
          data-background-color="orange"
        >
          <div class="md-title">
            <md-icon class="md-size-2x">account_balance_wallet</md-icon> Hoy
          </div>
        </md-card-header>
        <md-card-content v-if="tamano > 1 && totaleshoy">
          <p v-for="totalhoy in totaleshoy" :key="totalhoy">
            <b>{{ totalhoy.tipo }}:</b> ${{ formatPrice(totalhoy.monto) }}
          </p>
          <hr />
          <p v-if="tamano > 1">
            <b>Total:</b> ${{
              formatPrice(totaleshoy[0].monto - totaleshoy[1].monto)
            }}
          </p>
          <p v-if="tamano == 1">
            <b>Total:</b> ${{ formatPrice(totaleshoy[0].monto) }}
          </p>
        </md-card-content>
        <md-card-content v-else>
          <div
            class="alert alert-success alert-with-icon"
            data-notify="container"
          >
            <i data-notify="icon" class="material-icons">feedback</i>
            <span data-notify="message"
              >No se registraron ingresos o egresos hoy.</span
            >
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Global from "../../Global";

export default {
  name: "Resumen",
  data() {
    return {
      url: Global.url,
      totales: [],
      totaleshoy: [],
      tamano: 0
    };
  },
  mounted() {
    this.BuscarTotalHoy();
    this.BuscarTotal();
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    BuscarTotal() {
      axios
        .get(this.url + "caja/resumen/send", {
          headers: { ApiToken: localStorage.usertoken }
        })
        .then(Response => {
          if (Response.status == 200) {
            this.totales = Response.data;
          }
        })
        .catch(error => {
          alert(error);
        });
    },

    BuscarTotalHoy() {
      axios
        .get(this.url + "caja/resumen/send/hoy", {
          headers: { ApiToken: localStorage.usertoken }
        })
        .then(Response => {
          if (Response.status == 200) {
            this.totaleshoy = Response.data;
            this.tamano = Response.length;
          }
        })
        .catch(error => {
          alert(error);
        });
    }
  }
};
</script>
